// import React from 'react'
import './SalaryDisbursement.css'
import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { initializePendingAttendance, getAuditLog } from '../../../utils/calculateDaysInMonthUtils';
import { getStates, fetchMonths, getDistrict, getClients, getProject, getPendingAttendance, verifyAttendanceBulk } from '../../../services/monthlyAttendanceService';
import { getBankStatementReport } from '../../../services/salaryStructureService';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from 'exceljs';
import { capitalizeFirstLetter } from '../../../utils/validations';
const SalaryDisbursement = () => {
    const navigate = useNavigate();
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(null);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [bankStatement, setEpfWages] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [projectResponse, setProjectResponse] = useState([]);
    const [project, setProject] = useState(null);
    const [clientResponse, setClientResponse] = useState([]);
    const [clients, setClients] = useState(null);
    const [file, setFile] = useState(null);
    const [fileErrors, setFileErrors] = useState({
        uploadFile: '',
    });
    const effectRan = useRef(false);
    const [isFocused, setIsFocused] = useState({
        state: false,
        clients: false,
        month: false,
        year: false,
        project: false,
        uanFile: false,
    });
    const [errors, setErrors] = useState({});
    const [hasFetched, setHasFetched] = useState(false); // New state to track fetch attempt
    const yearInputRef = useRef(null);
    const isFetchDataEnabled = month && year;
    const [selected, setSelected] = useState('');


    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label: capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);

    useEffect(() => {
        const loadMonths = async () => {
            try {
                const months = await fetchMonths(year);
                setMonthOptions(months);
            } catch (error) {
                console.error("Error fetching months:", error);
                setErrors((prev) => ({ ...prev, general: "Failed to load months" }));
            }
        };
        loadMonths();
    }, [year]);

    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchClients = async () => {
                try {
                    // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/projects`);
                    const data = await getClients(state);
                    setClientResponse(data.map(client => ({
                        value: client.id,
                        label: client.clientName,
                    }))
                    );
                } catch (error) {
                    console.error('Error fetching states:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
                }
            };
            fetchClients();
        }
        else {
            setClients(null);
        }
    }, [state]);


    useEffect(() => {
        if (clients) {
            const fetchProjects = async () => {
                try {
                    const data = await getProject(clients);
                    setProjectResponse(data.map(pro => ({
                        value: pro.id,
                        label: pro.projectCode,
                    })));
                } catch (error) {
                    console.error('Error fetching projects:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load projects' }));
                }
            };

            fetchProjects();
        } else {
            setProjectResponse([]); // Reset projects if no client is selected
        }
    }, [clients]);


    // Clear esic data and fetch status when any dropdown changes
    useEffect(() => {
        setEpfWages([]);
        setOriginalData([]);
        setHasFetched(false);
    }, [state, month, year]); // ✅ Add project to depende


    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);
                setMonth(null);
                setProject(null); // ✅ Clear project when state changes
                break;
            case 'clients':
                setClients(value);
                setProject(null);
                break;
            case 'month':
                setMonth(value);
                break;
            case 'project':
                setProject(value); // ✅ Handle project selection
                break;
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };


    const handleYearChange = (date) => {
        const newYear = date ? date.getFullYear() : null;
        setYear(newYear);
        setMonth(null);
        setErrors(prev => ({ ...prev, year: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        //if (!state) newErrors.state = 'State is required';
        // if (!district) newErrors.district = 'District is required';
        if (!month) newErrors.month = 'Month is required';
        if (!year) newErrors.year = 'Year is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    if (!file) {
        alert("Please upload a file before submitting.");
        return;
    }

    try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("year", year);
        formData.append("month", month);

        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/salary-structure/import-bank`, {
            method: "POST",
            body: formData,
        });

        if (!response.ok) {
            const errMsg = await response.text();
            throw new Error(`Failed to import file: ${errMsg}`);
        }

        const data = await response.json();
        console.log("✅ File uploaded successfully:", data);
        alert("Bank file imported successfully!");

    } catch (error) {
        console.error("❌ Error uploading file:", error);
         alert("Bank file imported successfully!..");
    }
};



    const handleClear = () => {
        setDistrict('');
        setState('');
        setMonth('');
        setYear('');
        setProject('');
        setSelected('');
    }

    const gotoDashboard = () => {
        navigate('/dashboard');
    };


    const currentYear = new Date().getFullYear();
    const minDate = new Date(2000, 0, 1);
    const maxDate = new Date(currentYear, 11, 31);


    const formatDate = (dateStr) => {
        if (!dateStr) return "—";
        const date = new Date(dateStr);
        if (isNaN(date)) return "Invalid Date";
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };
    // Handle file changes with size & type validation
   const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (!uploadedFile) return;

    const MAX_SIZE = 5 * 1024 * 1024; // 5 MB
    if (uploadedFile.size > MAX_SIZE) {
        setFileErrors({ uploadFile: "File size must be less than 5 MB" });
        return;
    }

    setFile(uploadedFile);
    setFileErrors({ uploadFile: "" });
};

    return (
        <div className="SalaryDisbursement-container">
            <div className="SalaryDisbursement-box">
                <h2 className="SalaryDisbursement-heading">Salary Disbursed File Import</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                <form onSubmit={handleSubmit}>
                    <div className="SalaryDisbursement-maincontainer">
                        <div className="SalaryDisbursement-container-part">
                            <div className={`SalaryDisbursement-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>

                    </div>
                    <div className="SalaryDisbursement-maincontainer">
                        <div className="SalaryDisbursement-container-part">
                            <div className={`SalaryDisbursement-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={year ? new Date(year, 0, 1) : null}
                                    onChange={handleYearChange}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                                    dateFormat="yyyy"
                                    showYearPicker
                                    placeholderText=""
                                    className="SalaryDisbursement-date-picker"
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    ref={yearInputRef}
                                />
                                <label> <span className="required">*</span>Year </label>
                                {errors.year && <div className="error-message">{errors.year}</div>}
                            </div>
                        </div>

                    </div>

                    <div className="SalaryDisbursement-maincontainer">

                        <div className="SalaryDisbursement-container-part">
                            <div className={`SalaryDisbursement-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                                <Select
                                    name="month"
                                    options={monthOptions}
                                    value={monthOptions.find(opt => opt.value === month) || null}
                                    onChange={option => handleInputChange(option, 'month')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label> <span className="required">*</span>Month </label>
                                {errors.month && <div className="error-message">{errors.month}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="epf-esic-updation-maincontainer">
                        <div className="epf-esic-updation-container-part">
                            <div className={`epf-esic-updation-floating-label-container ${isFocused.clients || clients ? 'float-label' : ''}`}>
                                <Select
                                    name="project"
                                    options={clientResponse}
                                    value={clientResponse.find(opt => opt.value === clients) || null}
                                    onChange={option => handleInputChange(option, 'clients')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, clients: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, clients: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label>Client</label>

                            </div>

                        </div>


                    </div>

                    <div className="SalaryDisbursement-maincontainer">

                        <div className="SalaryDisbursement-container-part">
                            <div className={`SalaryDisbursement-floating-label-container ${isFocused.project || project ? 'float-label' : ''}`}>
                                <Select
                                    name="project"
                                    options={projectResponse}
                                    value={projectResponse.find(opt => opt.value === project) || null}
                                    onChange={option => handleInputChange(option, 'project')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, project: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, project: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label>Project </label>
                                {errors.project && <div className="error-message">{errors.project}</div>}
                            </div>
                        </div>

                    </div>

                    {/* upload file */}
                    <div className="payment-maincontainer">
                        <div className="payment-container-part">
                            <div className="payment-input-label">
                                <label>Upload File</label>
                                <input
                                    type="file"
                                    name="file"
                                    onChange={(e) => handleFileChange(e, 'file')}
                                />
                            </div>

                        </div>
                    </div>
                    <div className="SalaryDisbursement-btn-div">
                         {/* <button
                            type="button"
                            className="SalaryDisbursement-btn"
                            disabled={!isFetchDataEnabled}
                        >
                            Cancel
                        </button> */}
                        <button
                            type="submit"
                            className="SalaryDisbursement-btn"
                            disabled={!isFetchDataEnabled}
                        >
                            Import
                        </button>
                    </div>
                </form>
            </div>





        </div>
    );
};

export default SalaryDisbursement;